const PostNordLogo = () => (
    <svg
        role="img"
        aria-label="PostNord logo"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 13.8125V5.9375H14V13.8125C14 13.9161 13.9161 14 13.8125 14H2.1875C2.08395 14 2 13.9161 2 13.8125Z"
            fill="#00A0D6"
        />
        <path d="M5.9375 6.6875H2.9375V8.5625H5.9375V6.6875Z" fill="white" />
        <path
            d="M7.71875 5.375V2.09375H3.52382C3.45192 2.09375 3.38636 2.13486 3.35504 2.19958L2 5V5.375H7.71875Z"
            fill="#00A0D6"
        />
        <path
            d="M8.28125 5.375V2.09375H12.4727C12.5464 2.09375 12.6133 2.13692 12.6436 2.20408L13.9062 5V5.375H8.28125Z"
            fill="#00A0D6"
        />
    </svg>
);
export default PostNordLogo;
